<template>
  <div v-if="orders && isLoad">
    <main-title class="mt10 d-flex align-center space-between orders__title">
      <span>{{$t('orders.title')}}</span>

      <router-link class="btn btn_create-order ml10" tag="button" to="/client/orders/create">
        <img src="@/assets/images/plus.svg" alt />
        <span>{{$t('createOrder.title')}}</span>
      </router-link>
    </main-title>

    <orders-list v-if="orders.length > 0" />
    <div class="mt24" v-else>
      <p>{{$t("forms.noOrders")}}</p>

      <div class="mt24">
        <router-link
          class="btn btn_width"
          tag="button"
          to="/client/orders/create"
        >{{$t('buttons.create')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ordersList from "@/components/lists/orders/ordersList";
import mainContainer from "@/components/base/mainContainer";
import mainTitle from "@/components/base/mainTitle";

import orders from "@/mixins/orders";

export default {
  name: "orders",
  mixins: [orders],
  data() {
    return {
      isLoad: false
    };
  },
  components: {
    ordersList,
    mainContainer,
    mainTitle
  },
  computed: {
    ...mapGetters({
      orders: "orders/list"
    }),
    hasOrders() {
      return this.orders && this.orders.length > 0;
    }
  },
  async mounted() {
    if (!this.hasOrders) {
      this.fetchOrdersMixin();
    }

    this.isLoad = true;
    window.scrollTo({
      top: 0
    });
  }
};
</script> 

<style lang="scss">
@media (max-width: 768px) {
  .orders__title {
    width: 100%;
    height: 40px;

    span {
      width: 70%;
    }
  }
}
</style>